import callApi from "./apiCaller";

export const updateLastModerated = async (payload, investeeOrgId) => {
    await callApi(`investee-onboarding/v2/${investeeOrgId}/update_last_moderated`, "put", payload);
}